var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisitors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 59,
    viewBox: "0 0 61 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 58.5102,
    rx: 8,
    fill: "#FFEECC",
    fillOpacity: 0.958352
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1947_4290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6148 47.4617V43.4158C40.6148 41.2697 39.7623 39.2115 38.2447 37.694C36.7272 36.1765 34.669 35.324 32.5229 35.324H16.3393C14.1932 35.324 12.135 36.1765 10.6175 37.694C9.09997 39.2115 8.24744 41.2697 8.24744 43.4158V47.4617",
    stroke: "#A77C27",
    strokeWidth: 3.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4311 27.2321C28.9001 27.2321 32.5229 23.6093 32.5229 19.1403C32.5229 14.6713 28.9001 11.0485 24.4311 11.0485C19.9621 11.0485 16.3392 14.6713 16.3392 19.1403C16.3392 23.6093 19.9621 27.2321 24.4311 27.2321Z",
    stroke: "#A77C27",
    strokeWidth: 3.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7526 47.4618V43.4159C52.7513 41.623 52.1545 39.8813 51.0561 38.4643C49.9576 37.0473 48.4197 36.0353 46.6837 35.587",
    stroke: "#A77C27",
    strokeWidth: 3.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5918 11.3115C40.3324 11.7572 41.8751 12.7695 42.9768 14.1888C44.0785 15.6081 44.6765 17.3538 44.6765 19.1505C44.6765 20.9472 44.0785 22.6929 42.9768 24.1122C41.8751 25.5315 40.3324 26.5438 38.5918 26.9895",
    stroke: "#A77C27",
    strokeWidth: 3.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1947_4290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.551,
    height: 48.551,
    fill: "white",
    transform: "translate(6.22449 4.97961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitors);
export default __webpack_public_path__ + "static/media/visitors.1a2fa65246bce85263020aedadfc3a13.svg";
export { ForwardRef as ReactComponent };